export default __webpack_public_path__ + "static/media/Neophyte's Pants of Sovereign Rule.d1e11dfd.jpg";